import React, { useMemo, useState, useEffect } from 'react';
import { Input, Select, SelectItem, Table, TableBody, TableCell, TableColumn, TableHeader, TableRow } from '@nextui-org/react';
import { useDispatch, useSelector } from 'react-redux';
import { copy } from '../../../utils'
import { SchoolService } from '../../../services'


const SubjectStep = ({ grades, schoolYears }) => {
  const { form, onChange, subjects, onChangeSubject } = useForm();

  const focusInput = (key) => {
    document.getElementById(`subject-[${key - 1}]`)?.focus();
  }

  const filterGrades = useMemo(() => grades.filter(x => x.school_year_id === +form.schoolYear), [form.schoolYear, grades]);

  const onChangeForm = (value, target) => {
    onChange(value, target);
    onChange(true, 'fetchSubjects');
  }


  return (
    <div className="flex flex-col flex-1 gap-4">
      <div className="flex gap-4">
        <Select
          label="Año escolar"
          labelPlacement="outside"
          placeholder=" "
          variant="bordered"
          radius="sm"
          classNames={{
            base: 'w-full sm:max-w-[15rem]',
            inputWrapper: 'border-1 h-10',
            label: 'font-semibold',
          }}
          disallowEmptySelection={true}
          selectedKeys={!!form.schoolYear ? [form.schoolYear] : []}
          onSelectionChange={v => onChange(v.currentKey, 'schoolYear')}
        >
          {schoolYears.map((item) => (
            <SelectItem key={item.id} value={item.id}>{item.name}</SelectItem>
          ))}
        </Select>
        <Select
          label="Grado"
          labelPlacement="outside"
          placeholder=" "
          variant="bordered"
          radius="sm"
          classNames={{
            base: 'w-full sm:max-w-[15rem]',
            inputWrapper: 'border-1 h-10',
            label: 'font-semibold',
          }}
          disallowEmptySelection={true}
          onSelect={(v) => console.log(v)}
          selectedKeys={!!form.grade ? [form.grade] : []}
          onSelectionChange={v => onChangeForm(v.currentKey, 'grade')}
        >
          {filterGrades.map((item) => (
            <SelectItem key={item.id} value={item.id}>{item.name}</SelectItem>
          ))}
        </Select>
      </div>

      <Table
        aria-label="Materias"
        classNames={{
          wrapper: 'p-0 border-0 shadow-none',
          th: 'first:w-12',
        }}
        //isStriped
        onRowAction={focusInput}
        onCellAction={k => focusInput(k.split('.')[0])}
        selectionMode="multiple"
        selectedKeys={subjects.filter(x => x.isSelected).map(x => String(x.id))}
        onSelectionChange={v => onChangeSubject(v)}
      >
        <TableHeader>
          <TableColumn>Nombre</TableColumn>
          <TableColumn className="text-right">Horario/Semanal</TableColumn>
        </TableHeader>
        <TableBody items={subjects} emptyContent="No hay materias">
          {subjects.map((subject) => (
            <TableRow key={subject.id}>
              <TableCell>{subject.name}</TableCell>
              <TableCell className="flex justify-end">
                <Input
                  id={`subject-[${subject._index}]`}
                  classNames={{ base: 'w-28' }}
                  type="number"
                  variant="bordered"
                  value={subject.hours}
                  onValueChange={v => onChange(v, 'hours', subject._index)}
                />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div >
  )
}

const useForm = () => {
  const initialForm = {
    schoolYear: '',
    grade: '',
    fetchSubjects: false,
  };

  const dispatch = useDispatch()
  const user = useSelector(state => state.user);
  const scheduler = useSelector(state => state.scheduler);
  const [form, setForm] = useState(initialForm);
  const [subjects, setSubjects] = useState([]);
  const [sections, setSections] = useState([]);

  const onChange = (value, target, index) => {
    setForm(s => ({ ...s, [target]: value }));
  }

  const onChangeSubject = (values) => {
    if (values === 'all') {
      setSubjects(copy(subjects).map(x => ({ ...x, isSelected: true })))
      return
    }
    const _subjects = copy(subjects);
    const valuesToNumber = [...values].map(x => +x);
    const selectSubjects = _subjects.map(x => {
      if (valuesToNumber.includes(x.id)) return { ...x, isSelected: true };
      return { ...x, isSelected: false };
    });
    setSubjects(selectSubjects)
  }

  const fetchSubjects = async () => {
    const res = await SchoolService.schoolAdmin.getSubjects({ school_id: user.id, school_grade_id: +form.grade });
    const data = res.data.length > 0 ? res.data[0]?.subjects : [];
    setSubjects(data.map((x) => ({ ...x, _index: x.id, isSelected: false })));
  }


  const fetchSections = async () => {
    const res = await SchoolService.schoolAdmin.getSections({ school_id: user.id, school_grade_id: +form.grade });
    setSections(res)
  }

  // Para pasarle al componente schedule-step las materias y las secciones correspondientes
  useEffect(() => {
    if (sections.length < 0 || subjects.length < 0) return;
    const _sections = sections.map(x => ({ id: x.id, name: x.name }))
    const _subjects = subjects.map(x => ({ ...x, id: x.id, name: x.name, isSelected: x.isSelected }))

    dispatch({
      type: 'ADD_DATA', payload: {
        sections: _sections,
        subjects: _subjects,
        school_year_id: +form.schoolYear,
        school_grade_id: +form.grade,
      }
    });
  }, [sections, subjects])

  useEffect(() => {
    if (!form.grade || !form.fetchSubjects) return;
    fetchSubjects()
    fetchSections()
  }, [form.grade])

  useEffect(() => {
    const { sections, subjects, school_year_id, school_grade_id } = scheduler;
    if (sections.length < 1 || subjects.length < 1) return
    setSections(sections)
    setSubjects(subjects)

    setForm({
      schoolYear: String(school_year_id),
      grade: String(school_grade_id),
    })
  }, [])

  useEffect(() => {
  }, [scheduler])


  return {
    form,
    onChange,
    subjects,
    onChangeSubject
  }
}


export default SubjectStep;